<template>
  <div
    class="resizable-container"
    :style="{ width: containerWidth + 'px', flexShrink: 0 , height: height }"
  ref="container"
  >
  <div class="resizable-content">
    <slot></slot>
  </div>
  <div
    class="resizer-handle"
    @mousedown.stop="startDrag"
    :class="{ 'is-dragging': isDragging }"
    ref="handle"
  ></div>
  </div>
</template>

<script>
export default {
  name: 'ResizableContainer',
  props: {
    initialWidth: { type: Number, default: 300 },
    minWidth: { type: Number, default: 100 },
    maxWidth: { type: Number, default: null },
    edgeBuffer: { type: Number, default: 10 },
    height: { type: String, default: '100%' }
  },
  data() {
    return {
      containerWidth: this.initialWidth,
      isDragging: false,
      startX: 0,
      startWidth: 0,
      containerLeft: 0,  // 简化为容器左边界位置
      rafId: null
    }
  },
  methods: {
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startWidth = this.containerWidth;

      // 获取容器左边界在视口中的位置（解决flex布局偏移）
      this.containerLeft = this.$refs.container.getBoundingClientRect().left;

      // 绑定事件
      document.addEventListener('mousemove', this.handleDrag, { passive: true });
      document.addEventListener('mouseup', this.stopDrag);

      // 全局样式锁定
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';
    },

    handleDrag(e) {
      if (!this.isDragging) return;

      // 关键优化：基于容器左边界计算绝对宽度
      // 避免flex布局下父容器偏移导致的计算错误
      const currentWidth = e.clientX - this.containerLeft;
      let newWidth = currentWidth;

      // 边界处理
      if (newWidth < this.minWidth) newWidth = this.minWidth;
      if (this.maxWidth && newWidth > this.maxWidth) newWidth = this.maxWidth;

      // 平滑更新
      cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => {
        this.containerWidth = newWidth;
        this.$emit('resize', newWidth);  // 向外传递宽度变化
      });
    },

    stopDrag() {
      this.isDragging = false;
      cancelAnimationFrame(this.rafId);
      document.removeEventListener('mousemove', this.handleDrag);
      document.removeEventListener('mouseup', this.stopDrag);
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    }
  },
  watch: {
    initialWidth(newVal) {
      this.containerWidth = newVal;
    }
  },
  beforeDestroy() {
    this.stopDrag();
  }
}
</script>

<style scoped>
.resizable-container {
  position: relative;
  height: 100%;  /* 占满父容器高度 */
  overflow: hidden;
}

.resizable-content {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: auto;  /* 内部内容滚动，不影响容器尺寸 */
}

.resizer-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  background-color: transparent;
  z-index: 5;
  transition: background-color 0.2s;
}

.resizer-handle:hover {
  background-color: #e0e0e0;
}

.resizer-handle.is-dragging {
  background-color: #409eff;
}

/* 拖拽参考线 */
.resizer-handle.is-dragging::after {
  content: '';
  position: fixed;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #409eff;
  pointer-events: none;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/ResizableContainer.vue